<template>
  <header id="wrapper">
    <div class="site-nav box-shadow">
      <div class="container-w">
        <div style="display:flex;">
          <div style="flex: 1; align-item: flex-start">
            <a href="/" class="brand">
              <img :src="headerData.leading_image_data.leading_icon" />
            </a>
          </div>
          <div style="flex: 7; display:flex; align-items: center">
            <span class="header-top-content" v-html="headerData.text"></span>
          </div>
          <div style="display: flex; flex: 3; align-items: center; justify-content: flex-end;">
            <ul class="header-top-list">
              <li class="header-entrance-li" v-show="!$store.state.loginType">
                <router-link to="/login" class="entrance"> {{ $t('login.loginkey') }} </router-link>
              </li>
              <li class="header-entrance-li" v-show="$store.state.loginType">
                <router-link to="/myaccount" class="entrance">
                  {{ $t('header.myAccount') }}
                </router-link>
              </li>
              <li class="header-entrance-li">|</li>
              <li class="header-entrance-li" v-show="!$store.state.loginType">
                <router-link to="/login/register" class="entrance">
                  {{ $t('header.register') }}
                </router-link>
              </li>
              <li class="header-entrance-li" v-show="$store.state.loginType">
                <a @click="exitLogin" class="entrance" href="javascript:void(0);">
                  {{ $t('header.quit') }}
                </a>
              </li>
              <li class="header-entrance-li">|</li>
              <li class="header-entrance-li">
                <p class="entrance" @click="displayLinePopup" style="color: #000000">
                  {{ activeLineUrlName }}
                </p>
              </li>
            </ul>
          </div>
        </div>
        <el-row :gutter="180" style="display: flex; align-items: center">
          <el-col :span="24">
            <div id="header_nav" class="flex-row ml-md-auto active">
              <ul id="main-menu" class="nav nav-main active">
                <li class="menu-item menu-item-level-1" :class="{ active: 'Home' === isActive }"
                  @click="changeActivet('Home')">
                  <router-link to="/home"> {{ $t('header.frontPage') }} </router-link>
                </li>
                <li class="menu-item menu-item-level-1" :class="{ active: 'Stockrise' === isActive }"
                  @click="changeActivet('Stockrise')">
                  <router-link to="/stockmarket"> {{ $t('header.marketCenter') }} </router-link>
                </li>
                <li class="menu-item menu-item-level-1" :class="{ active: 'Operateday' === isActive }"
                  @click="changeActivet('Operateday')">
                  <router-link to="/operate"> {{ $t('header.applyFunding') }} </router-link>
                </li>
                <li
                  class="menu-item menu-item-level-1"
                  :class="{ active: 'Strategynow' === isActive }"
                  @click="changeActivet('Strategynow'),goStrategynow()"
                >
                  <router-link to="/myaccount/strategynow"> {{$t('myAccountPc.fundingAccount')}} </router-link>
                </li>
                <li
                  class="menu-item menu-item-level-1"
                  :class="{ active: 'Stockdetailed' === isActive }"
                  @click="changeActivet('Stockdetailed')"
                >
                  <router-link
                    :to="{
                      name: 'Stockdetailed',
                      query: { symbol: 'sh000001', direction: 0 },
                    }"
                  >
                    {{$t('header.longTrading')}}
                  </router-link>
                </li>
                <li
                  v-if="is_short_trading_enable == 1"
                  class="menu-item menu-item-level-1"
                  :class="{ active: 'Stockdetailed1' === isActive }"
                  @click="changeActivet('Stockdetailed1')"
                >
                  <router-link
                    :to="{
                      name: 'Stockdetailed',
                      query: { symbol: 'sh000001', direction: 1 },
                    }"
                  >
                    {{$t('header.shortTrading')}}
                  </router-link>
                </li>
                <li
                  class="menu-item menu-item-level-1"
                  :class="{ active: 'diagnosisStock' === isActive }"
                  @click="changeActivet('diagnosisStock')"
                >
                  <router-link to="/diagnosis_stock"> {{$t('myAccountPc.diagnosis')}} </router-link>
                </li>
                <li
                  class="menu-item menu-item-level-1"
                  :class="{ active: 'FoundWinners' === isActive }"
                  @click="changeActivet('FoundWinners')"
                >
                  <router-link to="/found_winners"> {{$t('myAccountPc.foundwinners')}} </router-link>
                </li>
                <!-- <li
                  class="menu-item menu-item-level-1"
                  :class="{ active: 'winners_diagnosis' === isActive }"
                  @click="changeActivet('winners_diagnosis')"
                >
                  <router-link to="/winners_diagnosis"> {{$t('header.bullStocks')}} </router-link>
                </li> -->
                <li
                  class="menu-item menu-item-level-1"
                  :class="{ active: 'stockactivity' === isActive }"
                  @click="changeActivet('stockactivity')"
                >
                  <router-link to="/stockactivity"> {{$t('header.activityArea')}} </router-link>
                </li>
                <li class="menu-item menu-item-level-1" :class="{ active: 'Download' === isActive }"
                  @click="changeActivet('Download')">
                  <router-link to="/download"> {{ $t('header.appDownload') }} </router-link>
                </li>
                <li class="menu-item menu-item-level-1" :class="{ active: 'Help' === isActive }"
                  @click="changeActivet('Help')">
                  <router-link to="/help/helpabout"> {{ $t('footer.aboutUs') }} </router-link>
                </li>
                <li class="menu-item menu-item-level-1" :class="{ active: 'Login' === isActive }"
                  @click="changeActivet('Login')">
                  <router-link to="/login"> {{ $t('header.userCenter') }} </router-link>
                </li>
                <!--<li class="menu-item menu-item-level-1" :class="{ 'active':'Agency'=== isActive }" @click="changeActivet('Agency')">
                  <a href="javascript:void(0);" @click="goAgency">我要推广</a>
                </li>-->
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <linePopup ref="lineListPopup"></linePopup>
  </header>
</template>
<script>
import linePopup from "./common/linepopup";
export default {
  name: "Header",
  components: {
    linePopup,
  },
  data() {
    return {
      headerData: {
        component_id: 1,
        component_name: "header",
        label: "field.HomeConfig_header_label",
        priority: 9,
        styles: {
          font_color: "#000000"
        },
        leading_image_data: {
          leading_icon: "",
          leading_icon_name: "",
          leading_icon_route: ""
        },
        text: "",
        redirect_url: "",
        display: true,
        icon: "el-icon-s-fold"
      },
      isActive: "home",
      header_description: "",
      headerLogo: '',
      activeLineUrlName: localStorage.getItem('lineUrlText'),
      is_short_trading_enable: 0,
    };
  },
  mounted: function () {
    this.getComponents();
    this.getRoute();
    this.headerDescription();
    this.get_logo();
    this.fetch_is_short_trading_enable();
  },
  methods: {
    getComponents() {
      let that = this;
      that
        .$http({
          url: "/app/Components/pcComponents",
          method: "post",
          data: {

          },
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            const components = JSON.parse(res.data.data[0].components_data);

            //Filter out the header data
            const componentHeader = components.find(component => component.component_id == 1);
            if(componentHeader){
              that.headerData = componentHeader;
            }
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    get_logo() {
      let that = this;
      that.$http({
        url: "/app/Home/logo",
        method: "POST",
        data: {
          logo_name: 'home_logo,login_register_logo'
        },
        transformRequest: [(data) => JSON.stringify(data)]
      })
        .then(ret => {
          let resData = ret.data;
          if (resData.code === 1) {
            that.headerLogo = resData.data.home_logo;
          }
        });
    },
    headerDescription() {
      let that = this;
      that
        .$http({
          url: "/app/Sysconfig/sysconfig/name",
          method: "post",
          data: {
            name: "pc_web_header_description",
          },
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.header_description = res.data.data;
          } else {
          }
        });
    },
    //注销登录
    exitLogin() {
      this.$store.state.loginType = false;
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("simulateToken");
      sessionStorage.removeItem("loginType");
      sessionStorage.removeItem("couponCheck");
      localStorage.removeItem('risk_notice_id');
      localStorage.removeItem('risk_notice_content');
      this.$notify.closeAll(); // remove risk notice popup
      this.$router.push({
        path: "/login",
      });
    },
    changeActivet(value) {
      let that = this;
      that.isActive = value;
    },
    changeHide() {
      $(".safe-wrap").toggle();
      $(".hide").toggleClass("active");
    },
    goStrategynow() {
      if (this.$store.state.loginType) {
        this.$store.state.accountType = 3;
        this.$router.push({
          path: "/myaccount/strategynow",
        });
      } else {
        this.$router.push({
          path: "/login",
        });
      }
    },
    goAgency() {
      if (this.$store.state.loginType) {
        this.$router.push({
          path: "/myaccount/agency",
        });
      } else {
        this.$router.push({
          path: "/login",
        });
      }
    },
    getRoute() {
      if (this.$route.query.direction == 1) {
        this.isActive = "Stockdetailed1";
      } else if (this.$route.query.direction == 0) {
        this.isActive = "Stockdetailed";
      } else {
        this.isActive = this.$route.name;
      }
    },
    fetch_is_short_trading_enable() {
      let that = this;
      that.$http({
        url: "/app/Sysconfig/sysconfig/name",
        method: "post",
        data: {
          name: "is_short_trading_enable",
        },
        transformRequest: [(data) => JSON.stringify(data)],
      }).then(function (res) {
        if (res.data.status == 200) {
          that.is_short_trading_enable = res.data.data;
          if (that.is_short_trading_enable == 0 && that.$store.state.loginType) {
            that.login_user_short_trading_enable();
          }
        }
      });
    },
    login_user_short_trading_enable() {
      let that = this;
      that.$http({
        url: "/app/User/user",
        method: "post",
        data: {},
      }).then(function (res) {
        if (res.data.status == 200) {
          that.is_short_trading_enable = res.data.data.has_short_capital;
        }
      });
    },
    getServerUrl() {
      let that = this;
      that
        .$http({
          url: "/app/Home/server_url",
          method: "POST",
          data: {

          },
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then((ret) => {
          let resData = ret.data;
          if (resData.code === 1) {
            // window.open(resData.data, "_blank ");
          }
        });
    },
    getHkUrl() {
      let that = this;
      that
        .$http({
          url: "/app/Sysconfig/sysconfig/name",
          method: "POST",
          data: {
            name: "hk_official_url",
          },
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then((ret) => {
          let resData = ret.data;
          if (resData.code === 1) {
            window.open(resData.data, "_blank ");
          }
        });
    },
    displayLinePopup() {
      this.$refs.lineListPopup.showlineListPopup();
    },
  },
  watch: {
    $route(to, from) {
      this.getRoute();
    },
    "$store.state.loginType"(newVal) {
      if (newVal && this.is_short_trading_enable == 0) {
        this.login_user_short_trading_enable();
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import url("./../assets/css/style.css");

.brand img{
  margin-right:20px;
}
.logo-box {
  float: left;
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.logo {
  width: 300px;
  height: 50px;
}

.header-top {
  height: 35px;
  background: var(--baseColor);
  font-size: 14px;
}

.header-warp {
  width: 100%;
  max-width: 1200px;
  min-width: 1000px;
  margin: auto;
}

.header-top-content {
  color: #000000;
  font-size: 14px;
  // line-height: 35px;
  // letter-spacing: 1px;
  float: left;
}

.header-top-list {
  float: right;
  display: flex;
  display: -webkit-box;
  display: -ms-flexbox;
}

.header-entrance-li {
  line-height: 35px;
  color: #000000;
}

.entrance {
  color: #000000;
  margin: 0 10px;
  cursor: pointer;
  font-size: 14px;
}

.entrance:hover {
  opacity: 0.8;
}

#wrapper {
  z-index: 9;
  width: 100%;
  min-width: 1000px;
  position: relative;
  background: rgba(255, 255, 255);

  .wrapper-header {
    width: 100%;
    max-width: 1200px;
    min-width: 1000px;
    margin: auto;
    height: 80px;
    position: relative;

    p {
      // background: url(../assets/img/login_01.png)
      //   center center no-repeat;
      background-size: auto 45px;
      width: 219px;
      height: 80px;
      float: left;
    }

    ul {
      display: block;
      float: right;

      li {
        display: inline-block;
        height: 80px;
        margin-right: 20px;

        a {
          display: inline-block;
          height: 80px;
          font-size: 20px;
          line-height: 80px;
          width: 100%;
          color: #666;
          text-align: center;
          position: relative;
          min-width: 60px;

          span {
            display: inline-block;
            width: 60px;
            height: 0;
            position: absolute;
            right: 0;
            left: 0;
            margin: 0 auto;
            bottom: 20px;
            border-bottom: 1px solid transparent;
          }
        }

        .header_active {
          color: #e85b25;

          span {
            border-bottom: 1px solid #e85b25 !important;
          }
        }
      }
    }
  }
}

header>div>button {
  background-color: transparent;
  font-size: 15px;
  cursor: pointer;
  color: white;
  display: inline-block;
  line-height: 80px;
  float: right;
}

.safe-wrap {
  position: relative;
  width: 100%;
  min-width: 1200px;
  color: #fff;
  background: #f0eadc;
}

.safe-top {
  height: 50px;
  line-height: 50px;
  padding: 0 100px 0 60px;
  background: url(../assets/img//sy_aq.png) 20px center no-repeat #21ad49;
}

.safe-top p {
  height: 50px;
}

.safe-top p a {
  display: inline-block;
  color: #ffe6ae;
  vertical-align: top;
  margin-right: 5px;
}

.safe-top p span {
  display: inline-block;
  height: 50px;
}

.safe-list ul {
  width: 100%;
  list-style: none;
}

.safe-list ul li {
  float: left;
  width: 22%;
  height: 25px;
  line-height: 25px;
  text-align: center;
}

.safe-list ul li a {
  font-size: 14px;
  color: #5fbf89;
}

span.hide {
  position: absolute;
  top: 0;
  right: 10px;
  z-index: 9;
  display: inline-block;
  width: 40px;
  padding: 20px 10px;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  background: url(../assets/img/sy_yc_up.png) center 7px no-repeat #3bbe60;
  padding-top: 25px;
  cursor: pointer;
}

span.hide a {
  color: #fff;
  font-size: 14px;
}

span.hide.active {
  background: url(../assets/img/sy_yc_down.png) center 15px no-repeat #3bbe60 !important;
}

span.hide.active a {
  display: none !important;
}

.fr {
  float: right !important;
}

.fl {
  float: left !important;
}

.txt-r {
  text-align: right !important;
}

.txt-l {
  text-align: left !important;
}

.txt-c {
  text-align: center !important;
}

.menu-item {
  float: left;
}

#header_nav .nav-main li a {
  padding: 0 17px;
  line-height: 45px;
  color: #020d10;
}

#header_nav .nav-main li.active a {
  background: transparent;
  color: var(--baseColor);
  font-weight: 700;
}

#header_nav .nav-main li.active a:after {
  height: 6px;
  display: block;
  width: auto;
  background: var(--baseColor);
  content: "";
  border-radius: 5px;
}
</style>





// WEBPACK FOOTER //
// src/components/header.vue